import React, { useState } from 'react'
import VisarjanSeva from './VisarjanSeva';
import LazySection from '../Home/LazySection';
import DarshanBookingBannerImg from "../../assets/images/new/DarshanBookingBannerImg.png";
import visarjanLandingPage from '../../assets/images/new/visarjanLandingPage.png'
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { Helmet } from 'react-helmet-async';

const GanapatiVisarjanLandingPage = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const handleScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };


    const FaqObj = [
        {
            QUESTION: "What is Ganesh Visarjan Day called?",
            ANSWER:
                "Ganesh Visarjan is celebrated on Anant Chaturdashi, also known as Ganesh Chaudas. On this day, devotees say goodbye to God Ganesh by immersing His idols in water with prayers and chants.",
            color: "#ffa415",
        },
        {
            QUESTION: "When is Ganesh Visarjan celebrated in 2025?",
            ANSWER:
                "In 2025, Ganesh Visarjan will be celebrated on Saturday, 6th September, between 05:57 AM and 09:15 PM.",
            color: "#fc5528",
        },
        {
            QUESTION: "Why is Ganesh Visarjan done in water?",
            ANSWER:
                "It is believed that when Lord Ganesh’s idol is immersed in water, it takes away all obstacles and negativity from the home. The immersion marks the completion of the festival with gratitude and hope for His return next year.",
            color: "#8139e7",
        },
        {
            QUESTION: "Why is Ganesh Visarjan done on Anant Chaturdashi?",
            ANSWER:
                "Anant Chaturdashi is considered the most auspicious day for Visarjan. Along with God Ganesh, devotees also worship Lord Vishnu in His infinite form, seeking blessings, protection, and prosperity.",
            color: "#8139e7",
        },

        {
            QUESTION: "What does Ganesh Visarjan teach us?",
            ANSWER:
                "Ganesh Visarjan teaches us an important life lesson that nothing is permanent. Just as we lovingly welcome Bappa and later let Him go, we learn to accept change and practice letting go with faith and devotion.",
            color: "#8139e7",
        },


        // {
        //   QUESTION: "Why is it important How Volunteer?",
        //   ANSWER:
        //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
        //   color: "#399be7",
        // },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };


    const webPageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.myomnamo.com/services/ganesh-visarjan-puja",
        "name": "Ganesh Visarjan Muhurat and Puja Vidhi Guide 2025 | Myomnamos",
        "description": "Find the accurate Ganesh Visarjan muhurat and step-by-step puja vidhi 2025. Know the right timings, rituals, and traditions with Myomnamo’s complete guide.",
        "url": "https://www.myomnamo.com/services/ganesh-visarjan-puja",
        "image": "https://www.myomnamo.com/static/media/newLogo.9c63a6b784d33fe408ca.jpg",
        "inLanguage": "en",
        "publisher": {
            "@type": "Organization",
            "name": "Myomnamo",
            "url": "https://www.myomnamo.com"
        }
    };

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.myomnamo.com"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Services",

            },
            {
                "@type": "ListItem",
                "position": 3,
                "name": "Ganesh Visarjan Puja",
                "item": "https://www.myomnamo.com/services/ganesh-visarjan-puja"
            }
        ]
    };

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "What is Ganesh Visarjan Day called?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ganesh Visarjan is celebrated on Anant Chaturdashi, also known as Ganesh Chaudas. On this day, devotees say goodbye to God Ganesh by immersing His idols in water with prayers and chants."
                }

            },
            {
                "@type": "Question",
                "name": "When is Ganesh Visarjan celebrated in 2025?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "In 2025, Ganesh Visarjan will be celebrated on Saturday, 6th September, between 05:57 AM and 09:15 PM."
                }
            },

            {
                "@type": "Question",
                "name": "Why is Ganesh Visarjan done in water?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "It is believed that when Lord Ganesh’s idol is immersed in water, it takes away all obstacles and negativity from the home. The immersion marks the completion of the festival with gratitude and hope for His return next year."
                }
            },
            {
                "@type": "Question",
                "name": "Why is Ganesh Visarjan done on Anant Chaturdashi?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Anant Chaturdashi is considered the most auspicious day for Visarjan. Along with God Ganesh, devotees also worship Lord Vishnu in His infinite form, seeking blessings, protection, and prosperity."
                }
            },
            {
                "@type": "Question",
                "name": "What does Ganesh Visarjan teach us?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ganesh Visarjan teaches us an important life lesson that nothing is permanent. Just as we lovingly welcome Bappa and later let Him go, we learn to accept change and practice letting go with faith and devotion."
                }
            }

        ]
    };
    return (
        <div>
            <Helmet>
                <title>Ganesh Visarjan Muhurat and Puja Vidhi Guide 2025 | Myomnamo</title>
                <meta name="description" content="Find the accurate Ganesh Visarjan muhurat and step-by-step puja vidhi 2025. Know the right timings, rituals, and traditions with Myomnamo’s complete guide." />
                <link rel="canonical" href="https://www.myomnamo.com/services/ganesh-visarjan-puja" />

                {/* Open Graph Tag */}

                {/* <!-- Open Graph tags --> */}
                <meta property="og:title" content="Ganesh Visarjan Muhurat and Puja Vidhi Guide 2025 | Myomnamo" />
                <meta
                    property="og:description"
                    content="Find the accurate Ganesh Visarjan muhurat and step-by-step puja vidhi 2025. Know the right timings, rituals, and traditions with Myomnamo’s complete guide."
                />
                <meta property="og:image" content="" />
                <meta
                    property="og:url"
                    content={`https://www.myomnamo.com/services/ganesh-visarjan-puja`}
                />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Myomnamo" />
                <meta property="og:locale" content="en_IN" />

                {/* <!-- Twitter Card tags --> */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Ganesh Visarjan Muhurat and Puja Vidhi Guide 2025 | Myomnamo" />
                <meta
                    name="twitter:description"
                    content="Find the accurate Ganesh Visarjan muhurat and step-by-step puja vidhi 2025. Know the right timings, rituals, and traditions with Myomnamo’s complete guide."
                />



                {/* Breadcrumb JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbSchema)}
                </script>

                {/* WebPage JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(webPageSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>

            </Helmet>

            <section className="page-header">
                <div
                    className="page-header__bg_serviceBanner"
                    style={{ backgroundImage: `url(${visarjanLandingPage})` }}
                ></div>
                <div className="container">
                    <h1
                        className="page-header__title bw-split-in-left"
                    // onClick={ExitIntenModalOpen}
                    >
                        Ganesh Visarjan
                    </h1>
                </div>
            </section>
            <div className=" p-4">
                {/* Page Title */}
                {/* <h2 className="text-center fw-bold mb-4">
                    The Ganesh Visarjan Story, Muhurat and Puja Vidhi Guide
                </h2> */}

                {/* Banner Image */}
                {/* <div className="text-center mb-4">
                    <img
                        src="https://shreeganesh.com/site/wp-content/uploads/2022/06/ganesh-chaturthi1.jpg" // replace with your image path
                        alt="Ganesh Visarjan"
                        className="img-fluid rounded shadow"
                        style={{ maxHeight: "350px", objectFit: "cover" }}
                    />
                </div> */}

                {/* Content Section */}
                <div className="mb-5">
                    <p>
                        Ganesh Chaturthi is a joyful Hindu festival that celebrates the rebirth of God Ganesha, the elephant-headed god of wisdom and prosperity. According to the Hindu lunar calendar, it falls in the month of Bhadrapada, usually between August and September. In 2025, Ganesh Visarjan will be celebrated on 6th September, and many states will declare it a public holiday. The final and grand immersion takes place on the 14th day, known as Anant Chaturdashi, which marks the end of the celebrations.
                    </p>
                    <p>
                        Lord Ganesha, lovingly known as Ganpati Bappa, is welcomed into homes with great excitement during the ten-day festival. His presence is believed to bring happiness and good fortune. But when the time comes for Visarjan, saying goodbye is emotional for devotees. With chants of “Ganpati Bappa Morya, Pudhchya Varshi Lavkar Ya”, people pray for His quick return next year. The farewell is filled with music, dance, and devotion, yet the mood remains heartfelt, with many remembering Bappa until He comes again next year.
                    </p>
                </div>

                {/* Navigation Cards */}
                <div className="row g-3 mb-5">
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("muhurat")}
                        >
                            Ganesh Visarjan 2025 Muhurat Timings <span>▶</span>
                        </button>
                    </div>
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("story")}
                        >
                            The Story Behind Ganesh Visarjan <span>▶</span>
                        </button>
                    </div>
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("stepguide")}
                        >
                            Step by Step Guide to Ganesh Visarjan Puja <span>▶</span>
                        </button>
                    </div>
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("proceedToBook")}
                        >
                            Proceed to book <span>▶</span>
                        </button>
                    </div>
                </div>



                {/* Muhurat Section */}
                <h3 className="fw-bold mb-3">Ganesh Visarjan 2025 Muhurat Timings</h3>
                <p>
                    People offer the final farewell to Ganesha’s idol on Anant Chaturdashi. Below are the auspicious timings
                    (Muhurat) for Ganesh Visarjan 2025.
                </p>

                {/* Timing Table */}
                <div id="muhurat" className="table-responsive">
                    <table className="table table-bordered text-center">
                        <thead className="table-light">
                            <tr>
                                <th>Event</th>
                                <th>Date</th>
                                <th>Timing</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Ganesh Visarjan on Anant Chaturdashi</td>
                                <td>Saturday, 6 September 2025</td>
                                <td>05:57 AM - 08:47 AM</td>
                            </tr>
                            <tr>
                                <td>Morning Muhurat</td>
                                <td>Sep 06</td>
                                <td>06:57 AM - 08:57 AM</td>
                            </tr>
                            <tr>
                                <td>Afternoon Muhurat</td>
                                <td>Sep 06</td>
                                <td>01:25 PM - 03:45 PM</td>
                            </tr>
                            <tr>
                                <td>Evening Muhurat</td>
                                <td>Sep 06</td>
                                <td>06:45 PM - 09:15 PM</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                {/* Story behind Visarjan */}
                <div id="story">
                    <h2 className="fw-bold mb-3">The Story Behind Ganesh Visarjan</h2>
                    <p>
                        The tradition of Ganesh Visarjan has a special meaning. There are two popular stories behind the tradition of Ganesh Visarjan, and both hold deep spiritual meaning. It is believed that on the last day of the festival, God Ganesh returns to Mount Kailash to be with His parents, God Shiva and Goddess Parvati.
                    </p>
                    <p>
                        The immersion also reminds us of the cycle of life and death, showing that everything in life is temporary. Devotees also believe that when Bappa’s idol is immersed, it takes away problems and negativity from their homes.
                        Another story comes from the time of Sage Ved Vyas and the writing of the Mahabharata. God Ganesha agreed to write the epic without stopping for ten days. He didn’t eat or drink, so Ved Vyas applied mud paste on His body to keep Him cool.
                        By the tenth day, the mud dried and Ganesha’s body heated up, looking like an idol. To cool Him down, Ved Vyas immersed Him in water. From this story, the tradition of worshipping Bappa for ten days and then immersing His idol in water began.

                    </p>
                </div>


                {/* Step By Step guidance */}
                <div id="stepguide">
                    <h3 className="fw-bold mb-3">Step by Step Guide to Ganesh Visarjan Puja</h3>
                    <p>
                        The Puja Vidhi is a way to bid farewell to the most beloved god of the devotees, Lord Ganesha. People do Lord Ganesha Puja for Ganesh Visarjan by following these steps:
                    </p>
                    <p>
                        <ol className="list-group list-group-numbered">
                            <li className="list-group-item">
                                The Puja starts with Lord Ganesha’s Aarti in the early morning with the entire family and relatives present.
                            </li>
                            <li className="list-group-item">
                                Devotees use <strong>Modak</strong>, a home-cooked sweet, for the Prasad and offer flowers to Lord Ganesha.
                            </li>
                            <li className="list-group-item">
                                After the Aarti, people march towards the Visarjan venue and pick up Lord Ganesha’s idol.
                                First move it towards yourself, signifying that Visarjan time has come.
                            </li>
                            <li className="list-group-item">
                                Pray to Lord Ganesha and express gratitude for staying at your home and solving your worries and problems.
                            </li>
                            <li className="list-group-item">
                                Take some <strong>Akshat</strong> (rice without oil) and offer it to Lord Ganesha.
                                Also, put some <strong>Dahi</strong> on his hands for good luck.
                            </li>
                            <li className="list-group-item">
                                Tie a red cloth with coconut, jaggery, and grains in it. This is the meal that’ll satisfy Lord Ganesha’s hunger during his trip back home.
                            </li>
                            <li className="list-group-item">
                                Sprinkle water on the person who performs the Puja Vidhi for Ganapati Visarjan.
                            </li>
                            <li className="list-group-item">
                                Give a final tour of your home to Lord Ganesha before leaving. It signifies his grace and blessings remain with you.
                            </li>
                            <li className="list-group-item">
                                Recite mantras and chant <strong>“Ganpati Bappa Morya”</strong> with devotion and energy.
                            </li>
                            <li className="list-group-item">
                                While leaving home, another person should hold a coconut. Offer it to Ganpati Bappa and break it in one go.
                            </li>
                            <li className="list-group-item">
                                Immerse the coconut along with Lord Ganesha’s idol.
                            </li>
                            <li className="list-group-item">
                                Perform Ganesh Aarti one last time at the Visarjan venue.
                            </li>
                            <li className="list-group-item">
                                Remove decorations from Lord Ganesha’s idol and dispose of them properly.
                                Then complete Ganesh Visarjan by immersing the idol in the water body.
                            </li>
                        </ol>
                    </p>

                </div>

                <div id='proceedToBook'>

                    <LazySection> <VisarjanSeva /></LazySection>
                </div>


                {/* FAQ */}
                <section className="faq-one faq-one--page">
                    <div
                        className="container"
                        style={{ display: "flex", flexDirection: "column" }}
                    >
                        <div className="section-title text-center">
                            <h6
                                className="sec-title__tagline bw-split-in-right"
                                style={{
                                    perspective: "400px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <img className="tagline-img" src={batuk} alt="" /> FAQ's
                            </h6>
                            <h3
                                className="sec-title__title bw-split-in-left"
                                style={{ perspective: "400px", textAlign: "center" }}
                            >
                                Frequently Asked Questions.
                            </h3>

                        </div>
                        <div className="row">
                            <div className="col-xl-2"></div>
                            <div className="col-xl-12">
                                <div className="faq-one__accordion careox-accordion">
                                    {FaqObj.map((faq, index) => (
                                        <div
                                            key={index}
                                            className={`accrodion ${activeIndex === index ? "active" : ""
                                                }`}
                                            style={{ "--accent-color": faq.color }}
                                        >
                                            <div
                                                className="accrodion-title"
                                                onClick={() => toggleFAQ(index)}
                                            >
                                                <h4>
                                                    <span
                                                        className="accrodion-title__number"
                                                        style={{ marginRight: "10px", fontWeight: "500" }}
                                                    ></span>
                                                    {faq.QUESTION}
                                                    <span className="accrodion-title__icon"></span>
                                                </h4>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    maxHeight: activeIndex === index ? "200px" : "0",
                                                    overflow: "hidden",
                                                    transition: "max-height 0.5s ease-in-out",
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>{faq.ANSWER}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-xl-2"></div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default GanapatiVisarjanLandingPage
